export default __webpack_public_path__ + "static/images/d32b9e10a406c88fad72fa715431352e.png";